/**
 * Общие константы приложения
 */

// API_URL: если не задан в env, используем пустую строку для относительных путей
// В production это работает, так как запросы идут на тот же домен
export const API_URL = process.env.REACT_APP_API_URL || '';

// Проверка и предупреждение в development
if (process.env.NODE_ENV === 'development' && !API_URL) {
  console.warn('[Constants] API_URL не установлен, используются относительные пути');
}

export const SOURCE_NAMES = {
  yandex: 'Яндекс.Музыка',
  youtube: 'YouTube',
  spotify: 'Spotify',
  soundcloud: 'SoundCloud'
};

export const ANIMATION_SPEED = {
  MIN: 1.0,
  MAX: 1.2,
  DEFAULT: 1.0
};

